import React from 'react';
import ListViewFilterChip from '../ListViewFilterChip';
import { ChipsScroller } from './ListViewFilterChips.style';
import useScrollOverflow from '../../../hooks/useScrollOverflow';
import type { ActiveFilter } from '../../types';

interface ListViewFilterChipsProps {
  activeFilters: ActiveFilter[];
  onEditFilter: (filter: ActiveFilter) => void;
  onRemoveFilter: (filterID: string) => void;
}

/* The filters currently narrowing the list, as a row of chips. However many
   there are, they stay on one line and scroll sideways, faded at whichever
   edge still has chips behind it */
const ListViewFilterChips = ({
  activeFilters,
  onEditFilter,
  onRemoveFilter
}: ListViewFilterChipsProps) => {
  const { ref, hasBefore, hasAfter } = useScrollOverflow();
  if (activeFilters.length === 0) return null;
  return (
    <ChipsScroller ref={ref} $fadeBefore={hasBefore} $fadeAfter={hasAfter}>
      {activeFilters.map((filter) => (
        <span key={filter.id} tw="flex-none mr-4">
          <ListViewFilterChip
            filter={filter}
            onEdit={onEditFilter}
            onRemove={onRemoveFilter}
          />
        </span>
      ))}
    </ChipsScroller>
  );
};

export default ListViewFilterChips;
